import React from "react";

/**
 * Delete button component
 */
const DeleteButton = ({ onDelete }) => {
  return (
    <div style={{ marginTop: "16px" }} onClick={onDelete}>
      <button
        style={{
          width: "100%",
          height: "40px",
          backgroundColor: "white",
          borderRadius: "5px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          border: "2px solid red",
          color: "red",
          marginTop: "10px",
        }}
      >
        Delete Text Box
      </button>
    </div>
  );
};

export default DeleteButton;
